import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_WIDTH = 12;
const DEFAULT_HEIGHT = 12;
const DEFAULT_COLOR = "var(--label-critical)";

function IconCross({
    class: cssClass,
    width = DEFAULT_WIDTH,
    color
}: Omit<IconProps, "height">) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const height = width * DEFAULT_HEIGHT / DEFAULT_WIDTH;

    return (
        <svg class={cssClass} width={width} height={height} viewBox="0 0 12 12">
            <path
                fill={fill}
                fill-rule="evenodd"
                d="M6 3.898L2.317.215c-.282-.282-.759-.284-1.052.01l-1.04 1.04c-.298.298-.298.764-.01 1.052L3.898 6 .215 9.683c-.282.282-.284.759.01 1.052l1.04 1.04c.298.298.764.298 1.052.01L6 8.102l3.683 3.683c.282.282.759.284 1.052-.01l1.04-1.04c.298-.298.298-.764.01-1.052L8.102 6l3.683-3.683c.282-.282.284-.759-.01-1.052l-1.04-1.04c-.298-.298-.764-.298-1.052-.01L6 3.898z"/>
        </svg>
    );
}

export default IconCross;
